import { EntityAnticipoAprobado } from "../../../../../shared/Domain/Catalogos/EntityAnticipoAprobado";
import { EntityEmpresas } from "../../../../../shared/Domain/Catalogos/EntityEmpresas";
import { EntityFlujoOT } from "../../../../../shared/Domain/Catalogos/EntityFlujoOT";
import { EntityFlujosDelegacion } from "../../../../../shared/Domain/Catalogos/EntityFlujosDelegacion";
import { EntityOT } from "../../../../../shared/Domain/Catalogos/EntityOT";
import { EntityProyectos } from "../../../../../shared/Domain/Catalogos/EntityProyectos";
import { EntitySelectBase } from "../../../../../shared/Domain/Catalogos/EntitySelectBase";
import { EntityGasto } from "../../../../../shared/Domain/EntityGasto";

export interface EntityResponseInitialData {
    ot: EntitySelectBase<EntityOT>[];
    empresa: EntitySelectBase<EntityEmpresas>[];
    anticipo: EntitySelectBase<EntityAnticipoAprobado>[];
    gasto: EntityGasto[];
    gastoAsociado: EntityGasto[];
    flujo: EntityFlujoOT[];
    flujoDelegacion: EntityFlujosDelegacion[];
    proyectos: EntitySelectBase<EntityProyectos>[];
}

export const initEntityResponseInitialData: EntityResponseInitialData  = {
    ot: [],
    empresa: [],
    anticipo: [],
    gasto: [],
    gastoAsociado: [],
    flujo: [],
    flujoDelegacion: [],
    proyectos: []
}